// extracted by mini-css-extract-plugin
module.exports = {"custom-offcanvas":"styles-module__custom-offcanvas___3uipj"};